// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbvue/build/css/mdb.css';
import Vue from 'vue';
import App from './App';
import router from './router/router';
import { setLang } from "./language";

/* eslint-disable no-new */
Vue.config.productionTip = false;

const createVueInstance = function() {
    new Vue({
        el: '#app',
        router,
        components: { App },
        template: '<App/>',
    });
};

const userLang = navigator.language || navigator.userLanguage;
if (userLang == "fi-FI") {
    setLang(1);
} else {
    setLang(0);
}
createVueInstance();